import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { CancelationReason } from 'src/app/assabil-kernel/models/entities/control-tables/cancelation-reason';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { CancelationReasonRequest } from 'src/app/assabil-kernel/models/dtos/control-tables/cancelation-reason-request';


@Component({
  selector: 'app-cancelation-reason-list',
  templateUrl: './cancelation-reason-list.component.html',
  styleUrls: ['./cancelation-reason-list.component.scss']
})
export class CancelationReasonListComponent extends BasePage2<CancelationReason> {

  // Filter fields
  // ---------------------------------------------------
  code: string;
  name: string;
  // ---------------------------------------------------
      
  // ---------------------------------------------------
  cancelationReasons: CancelationReason[] = [];
  // ---------------------------------------------------
  

  constructor(
      protected toastr            : ToastrService,
      protected router            : Router,
      protected baseService       : BaseService,
      protected leanUtilsService  : LeanUtilsService,
      protected location          : Location,
      protected controlService        : ControlTablesService,
      ) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName = 'cancelationReason';
  }



  listFields = [
      { prop: 'cancelationReasonCode', name: 'Code',  insertOnly : true},
      { prop: 'name', name: 'Name' },

  ]

//-------------------------------------------------------------------
getRows(): CancelationReason[] {
      return this.cancelationReasons;
}
//-------------------------------------------------------------------


//-------------------------------------------------------------------
saveRow(cancelationReason : CancelationReason): Promise<CancelationReason> {
    let request  : CancelationReasonRequest = new CancelationReasonRequest(this.controlService.getUserInfo());
    request.cancelationReason = cancelationReason;
    return this.controlService.save(this.entityName, request);
  }
//----------------------------------------------------------------------

  
//----------------------------------------------------------------------
new(){
    let entity : CancelationReason = new CancelationReason();
    entity.inserted = true;
    entity.edit = true;
    this.cancelationReasons.push(entity);
    this.cancelationReasons = [...this.cancelationReasons];
    }
//----------------------------------------------------------------------
 

//-------------------------------------------------------------------
  loadData() {
    let request         : BaseRequest = this.controlService.getRequest();
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlService.getList(this.entityName, request).then(result => {
        this.cancelationReasons = result;
    })
  }
//-------------------------------------------------------------------

}
